import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  AppBar,
  Toolbar,
  TextField,
  Button,
  Paper,
  CircularProgress,
  Container,
  CssBaseline,
  Snackbar,
  SnackbarContent,
  IconButton,
  Input,
  InputLabel,
  FormControl,
  FormHelperText,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Select,
  MenuItem,
  Avatar,
  Grid,
  CardContent,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
  Error,
  Close,
  Email,
  Help,
  WebAsset,
  Timeline,
  Equalizer,
  DirectionsBus,
} from "@material-ui/icons";

import { useHistory } from "react-router-dom";
import MaskedInput from "react-text-mask";
import { useSnackbar } from "notistack";

import PinInput from 'react-pin-input'

import icon from "../../assets/img/logo_white.svg";
import CardShowcase from "../../assets/svg/cards.svg";

import Footer from "./footer.jsx";

import { withLocalize, Translate } from "react-localize-redux";
import { AdminService, FinanceService, ReportingService, Validator } from "../../utils/web_config";
import axiosRetry from "axios-retry";
const axios = require("axios");
axiosRetry(axios, { retries: 3 });

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  paper: {
    padding: 15,
  },
  btn: {
    textTransform: "capitalize",
  },
}));

function MaskedNID(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        /\d/,
        " ",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        " ",
        /\d/,
        " ",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        " ",
        /\d/,
        " ",
        /\d/,
        /\d/,
      ]}
      placeholderChar={"\u2000"}
      showMask={false}
      keepCharPositions={true}
    />
  );
}

function TextMaskPhone(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        "2",
        "5",
        "0",
        " ",
        /\d/,
        /\d/,
        /\d/,
        " ",
        /\d/,
        /\d/,
        /\d/,
        " ",
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholderChar={"\u2000"}
      showMask={false}
      keepCharPositions={false}
    />
  );
}

const outlets=[
  {code:"IIS1001CO",name:"CHIC COGEBANQUE"},
  {code:"IIS1002CE",name:"Nyabugogo bus park"},
  {code:"IIS1003CE",name:"Giporoso bus park"},
  {code:"IIS1004CE",name:"Musanze bus park"},
  {code:"IIS1005CE",name:"Kayonza bus park"},
  {code:"IIS1006CE",name:"Kinigi"},
  {code:"IIS1007CE",name:"Gahunga"},
  {code:"IIS1008CE",name:"Cyanika"},
  {code:"IIS1009CE",name:"Vunga"},
]


function PreRegistration(props) {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [accountData, setAccountData] = useState({});
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [nid, setNid] = useState({ value: "", error: "" });
  const [idData, setIdData] = useState({
    loading: false,
    saving: false,
    open: false,
  });

  const [otpData, setOtpData] = useState({
    loading: false,
    saving: false,
    open: false,
    data: [],
  });

  const [otp, setOtp] = useState({ value: "", error: "" });

  const [clientFirstName, setFirstName] = useState({ value: "", error: "" });
  const [clientMiddleName, setMiddleName] = useState({ value: "", error: "" });
  const [clientLastName, setLastName] = useState({ value: "", error: "" });
  const [clientPhoneNumber, setPhoneNumber] = useState({
    value: "",
    error: "",
  });

  const [clientEmail, setEmail] = useState({ value: "", error: "" });
  const [clientLocation, setLocation] = useState({ value: "", error: "" });
  const [clientBranch, setBranch] = useState({ value: "", error: "" });
  const [company, setCompany] = useState({ value: "", error: "" });


  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);
  }, []);

  const onNidChange = (event) => {
    if (event.target.value === "") {
      setNid({ value: "", error: "Enter ID number to continue" });
    } else {
      setNid({ value: event.target.value, error: "" });
    }
  };

  const onOtpChange = (v,i) => {
    if (v === "") {
      notify( "error", "Enter OTP number sent to your phone" );
    } else {
      setOtp({ value: v, error: "" });
    }
  };

  const onSearchClick = () => {
    if (nid.value === "") {
      setNid({ value: "", error: "Enter ID number to continue." });
    } else {
      getIDInfo();
    }
  };

  const onFirstNameChange = (event) => {
    if (event.target.value === "") {
      setFirstName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("pre_registration.forms.hints.client_first_name")
            }
          </Translate>
        ),
      });
    } else {
      setFirstName({ value: event.target.value, error: "" });
    }
  };
  const onMiddleNameChange = (event) => {
    if (event.target.value === "") {
      setMiddleName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("pre_registration.forms.hints.client_middle_name")
            }
          </Translate>
        ),
      });
    } else {
      setMiddleName({ value: event.target.value, error: "" });
    }
  };
  const onLastNameChange = (event) => {
    if (event.target.value === "") {
      setLastName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("pre_registration.forms.hints.client_last_name")
            }
          </Translate>
        ),
      });
    } else {
      setLastName({ value: event.target.value, error: "" });
    }
  };
  const onPhoneNumberChange = (event) => {
    if (event.target.value === "") {
      setPhoneNumber({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("pre_registration.forms.hints.client_phone_number")
            }
          </Translate>
        ),
      });
    } else {
      setPhoneNumber({ value: event.target.value, error: "" });
    }
  };
  const onEmailChange = (event) => {
    if (event.target.value === "") {
      setEmail({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("pre_registration.forms.hints.client_email")
            }
          </Translate>
        ),
      });
    } else {
      setEmail({ value: event.target.value, error: "" });
    }
  };

  const onCompanyChange = (event) => {
    if (event.target.value === "") {
      setCompany({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("pre_registration.forms.hints.company")
            }
          </Translate>
        ),
      });
    } else {
      setCompany({ value: event.target.value, error: "" });
    }
  };

  const onLocationChange = (event) => {
    if (event.target.value === "") {
      setLocation({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("pre_registration.forms.hints.client_location")
            }
          </Translate>
        ),
      });
    } else {
      setLocation({ value: event.target.value, error: "" });
    }
  };
  const onBranchChange = (event) => {
    if (event.target.value === "") {
      setBranch({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("pre_registration.forms.hints.client_branch")
            }
          </Translate>
        ),
      });
    } else {
      setBranch({ value: event.target.value, error: "" });
    }
  };

  /////////////////////////////

  const onRegisterClick = () => {
    if (clientFirstName.value === "") {
      setFirstName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("pre_registration.forms.hints.client_first_name")
            }
          </Translate>
        ),
      });
    }
    // else if (clientLastName.value === "") {
    //   setLastName({
    //     value: "",
    //     error: (
    //       <Translate>
    //         {({ translate }) =>
    //           translate("pre_registration.forms.hints.client_last_name")
    //         }
    //       </Translate>
    //     ),
    //   });
    // } 
    //   else if (clientMiddleName.value === "") {
    //   setMiddleName({
    //     value: "",
    //     error: (
    //       <Translate>
    //         {({ translate }) =>
    //           translate("pre_registration.forms.hints.client_middle_name")
    //         }
    //       </Translate>
    //     ),
    //   });
    // }
    else if (clientPhoneNumber.value === "") {
      setPhoneNumber({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("pre_registration.forms.hints.client_phone_number")
            }
          </Translate>
        ),
      });
    }else if (!clientPhoneNumber.value.startsWith("250")) {
      setPhoneNumber({
        value: clientPhoneNumber.value,
        error: (
          <Translate>
            {({ translate }) =>
              translate("pre_registration.forms.hints.client_phone_number_starts")
            }
          </Translate>
        ),
      });
    }
    else if (clientPhoneNumber.value.replace(/\s/g, "").length!==12) {
      setPhoneNumber({
        value: clientPhoneNumber.value,
        error: (
          <Translate>
            {({ translate }) =>
              translate("pre_registration.forms.hints.client_phone_number_invalid")
            }
          </Translate>
        ),
      });
    }
    else if (clientEmail.value === "") {
      console.log(clientPhoneNumber.value)
      setEmail({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("pre_registration.forms.hints.client_email")
            }
          </Translate>
        ),
      });
    }
    else if (!new Validator().validEmail(clientEmail.value)) {
      setEmail({
        value: clientEmail.value,
        error: (
          <Translate>
            {({ translate }) =>
              translate("users.forms.hints.user_email_invalid")
            }
          </Translate>
        ),
      });
    }
    else if (clientLocation.value === "") {
      setLocation({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("pre_registration.forms.hints.client_location")
            }
          </Translate>
        ),
      });
    } else if (clientBranch.value === "") {
      setBranch({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("pre_registration.forms.hints.client_branch")
            }
          </Translate>
        ),
      });
    } else {
      register()
    }
  };

  ///////////////////////////////////
  /////////////////////
  const notify = (variant, msg, status) => {
    // if (status == 401) {
    //   history.push("/", { expired: true });
    // }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };
  ///////////////////////////////////

  const getIDInfo = () => {
    const createInstance = axios.create(
      new AdminService().getMsHeaders(accountData.token)
    );

    setIdData({ ...idData, loading: true });

    const data = {
      document_number: nid.value.replace(/ /g, ""),
    };

    createInstance
      .post(new ReportingService().NIDA_DOCUMENT, data)
      .then(function (response) {
        setIdData({ ...idData, loading: false });

        const d = response.data;

        if (d.data?.applicationNumber == null) {
          notify("error", "Your ID number is not found");
        } else {
          setFirstName({ value: d.data.foreName, error: "" });
          setLastName({ value: d.data.surnames, error: "" });
          setLocation({ value: d.data.district, error: "" });
          setMiddleName({value:nid.value,error:''})
          setIdData({ ...idData, loading: false, data: d.data, open: true });
        }
      })
      .catch(function (error) {
        setIdData({ ...idData, loading: false });

        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  ///////////////////////////////////

  const sendOtp = () => {
    const createInstance = axios.create(
      new AdminService().getMsHeaders(accountData.token)
    );

    setIdData({ ...idData, saving: true });
    var code = ("" + Math.random()).substring(2, 6);
    //console.log(code)

    const data = {
      receiver: clientPhoneNumber.value.replace(/ /g, ""),
      text:
        "Hey " +
        clientFirstName.value +
        " , Your OTP code for SafariBus card pre-registration is " +
        code,
    };

    createInstance
      .post(new ReportingService().SEND_SMS, data)
      .then(function (response) {
        setIdData({ ...idData, saving: false });

        const d = response.data;

        setOtpData({ ...otpData, otp: code, open: true });
        notify("success", d.message);
      })
      .catch(function (error) {
        setIdData({ ...idData, saving: false });

        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  //////////////////////////////////////////
  const doRegister = () => {
  
    if (otp.value === "") {
      setOtp({ value: "", error: "Enter OTP number sent to your phone" });
      return;
    } else if (otp.value.replace(/ /g, "") != otpData.otp) {
      setOtp({
        value: otp.value,
        error:
          "The OTP code is invalid, enter the one we sent you on your phone",
      });
      return;
    }

    register()
  };

    ///////////////////////////////////

    const register = () => {
      const createInstance = axios.create(
        new AdminService().getMsHeaders(accountData.token)
      );
  
      setIdData({ ...idData, saving: true });
 
      const data ={
        "id_number": nid.value.replace(/ /g, ""),
        "first_name": clientFirstName.value,
        "last_name": clientLastName.value,
        "phone_number": clientPhoneNumber.value.replace(/ /g, ""),
        "email": clientEmail.value,
        "client_location": clientLocation.value,
        "pickup_branch": clientBranch.value,
        "company": company.value==""?"No company":company.value,
        "nida_data": idData.data,
      }
  
      createInstance
        .post(new FinanceService().NEW_CARD_REGISTRATION, data)
        .then(function (response) {
          setIdData({ ...idData, saving: false });
  
          const d = response.data;
  
          setOtpData({data:[]})
          setNid({value:'',error:''})
          setFirstName({value:'',error:''})
          setLastName({value:'',error:''})
          setPhoneNumber({value:'',error:''})
          setEmail({value:'',error:''})
          setLocation({value:'',error:''})
          setBranch({value:'',error:''})
          setCompany({value:'',error:''})
          setMiddleName({value:'',error:''})
        
          setIdData({})

          notify("success", "You are registered successfully");
          //history.push("/", { expired: false })
        })
        .catch(function (error) {
          setIdData({ ...idData, saving: false });
  
          var e = error.message;
          if (error.response) {
            e = error.response.data.message;
          }
  
          notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
        });
    };

  return (
    <div className={classes.root}>
      <CssBaseline />
      {/* Dialogs---------------------- */}
      <Dialog
        open={idData.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
        onClose={() => setIdData({ ...idData, open: false })}
      >
        <DialogTitle id="alert-dialog-title">
          Complete pre-registration
        </DialogTitle>
        {otpData.open ? (
          <DialogContent>
          Enter OTP code sent to your phone number
            <Box mt={3} width={1} display='flex' justifyContent='center'>
            <PinInput 
  length={4} 
  initialValue=""
  //secret 
  onChange={onOtpChange}
  type="numeric" 
  inputMode="number"
  style={{padding: '10px',borderRadius:"7px"}}  
  inputStyle={{borderColor: theme.palette.secondary.main}}
  inputFocusStyle={{borderColor: theme.palette.primary.main}}
  onComplete={(value, index) => {}}
  autoSelect={true}

/>
             
            </Box>
          </DialogContent>
        ) : (
          <DialogContent>
            <Box display="flex" width={1} justifyContent="center">
              <img
                style={{ height: 130, width: 110 }}
                src={"data:image/jpg;base64," + idData?.data?.photo}
                alt="Person"
              />
            </Box>
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    type="text"
                    value={clientFirstName.value}
                    placeholder={translate(
                      "pre_registration.forms.hints.client_first_name"
                    )}
                    label={
                      <Translate id="pre_registration.forms.labels.client_first_name" />
                    }
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    onChange={onFirstNameChange}
                    helperText={clientFirstName.error}
                    error={clientFirstName.error !== ""}
                  />
                )}
              </Translate>
            </Box>
            
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    type="text"
                    value={clientLastName.value}
                    placeholder={translate(
                      "pre_registration.forms.hints.client_last_name"
                    )}
                    label={
                      <Translate id="pre_registration.forms.labels.client_last_name" />
                    }
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    onChange={onLastNameChange}
                    helperText={clientLastName.error}
                    error={clientLastName.error !== ""}
                  />
                )}
              </Translate>
            </Box>
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    type="text"
                    value={clientMiddleName.value}
                    placeholder={translate(
                      "pre_registration.forms.hints.client_middle_name"
                    )}
                    label={
                      <Translate id="pre_registration.forms.labels.client_middle_name" />
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                    fullWidth
                    onChange={onMiddleNameChange}
                    helperText={clientMiddleName.error}
                    error={clientMiddleName.error !== ""}
                  />
                )}
              </Translate>
            </Box>
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    type="text"
                    value={clientPhoneNumber.value}
                    placeholder={translate(
                      "pre_registration.forms.hints.client_phone_number"
                    )}
                    label={
                      <Translate id="pre_registration.forms.labels.client_phone_number" />
                    }
                    fullWidth
                    onChange={onPhoneNumberChange}
                    helperText={clientPhoneNumber.error}
                    error={clientPhoneNumber.error !== ""}
                    InputProps={{
                      inputComponent: TextMaskPhone,
                    }}
                  />
                )}
              </Translate>
            </Box>
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    type="text"
                    value={clientEmail.value}
                    placeholder={translate(
                      "pre_registration.forms.hints.client_email"
                    )}
                    label={
                      <Translate id="pre_registration.forms.labels.client_email" />
                    }
                    fullWidth
                    onChange={onEmailChange}
                    helperText={clientEmail.error}
                    error={clientEmail.error !== ""}
                  />
                )}
              </Translate>
            </Box>
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    type="text"
                    value={clientLocation.value}
                    placeholder={translate(
                      "pre_registration.forms.hints.client_location"
                    )}
                    label={
                      <Translate id="pre_registration.forms.labels.client_location" />
                    }
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    onChange={onLocationChange}
                    helperText={clientLocation.error}
                    error={clientLocation.error !== ""}
                  />
                )}
              </Translate>
            </Box>
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    type="text"
                    value={company.value}
                    placeholder={translate(
                      "pre_registration.forms.hints.company"
                    )}
                    label={
                      <Translate id="pre_registration.forms.labels.company" />
                    }
                    fullWidth
                    onChange={onCompanyChange}
                    helperText={company.error}
                    error={company.error !== ""}
                  />
                )}
              </Translate>
            </Box>
            <Box mt={2}>
              <FormControl
                fullWidth
                variant="outlined"
                size="small"
                error={clientBranch.error !== ""}
              >
                <InputLabel>
                  <Translate id="pre_registration.forms.labels.client_branch" />
                </InputLabel>
                <Select
                  label={
                    <Translate id="pre_registration.forms.labels.client_branch" />
                  }
                  value={clientBranch.value}
                  onChange={onBranchChange}
                >
                  {outlets.map((loc, i) => (
                    <MenuItem value={loc.code}>{loc.name}</MenuItem>
                  ))}
                </Select>
                <FormHelperText>{clientBranch.error}</FormHelperText>
              </FormControl>
            </Box>
          </DialogContent>
        )}
        <DialogActions>
          <Button
            onClick={() => {
              if(!otpData.open){
              setIdData({  open: false });
              }
              setOtpData({  open: false, });
            }}
            variant="outlined"
            color="primary"
          >
           {!otpData.open? <Translate id="users.forms.buttons.cancel" />:<Translate id="users.forms.buttons.back" />}
          </Button>
          <Button
            disabled={idData.saving}
            variant="contained"
            color="primary"
            onClick={() => {
              if (otpData.open) {
                doRegister();
              } else {
                onRegisterClick();
              }
            }}
            disableElevation
          >
            {idData.saving ? (
              <CircularProgress size={23} />
            ) : otpData.open ? (
              "Confirm"
            ) : (
              "Continue"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ------------------------- */}
      <AppBar position="static" color="primary" elevation={0}>
        <Toolbar>
          <Box mr={2}>
            <img
              src={icon}
              style={{ height: 45 }}
              className={classes.icon}
              alt="Icon"
              onClick={() => history.push("/")}
            />
          </Box>
          <Typography variant="h5" className={classes.title}>
            Card pre-registration
          </Typography>
          <IconButton>
            <Help />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Container maxWidth="sm">
        <Box pt={10}>
          <Box p={2} display="flex" flexDirection="column">
            <img
              src={CardShowcase}
              style={{ height: 170 }}
              alt="Cards showcase"
            />
            <Box
              mb={1}
              display="flex"
              alignItems="center"
              justifyContent="center"
            ></Box>
            <Typography color="textSecondary" align="center">
              Enter your national identification number for pre-registration.
            </Typography>
          </Box>
          <Box mt={3}>
            <FormControl fullWidth error={nid.error != ""}>
              <InputLabel htmlFor="formatted-code" size="small">
                National ID number
              </InputLabel>
              <Input
                onChange={onNidChange}
                value={nid.value}
                color="primary"
                varient="outlined"
                inputComponent={MaskedNID}
                placeholder="Enter your ID number here"
              />
              <FormHelperText id="code">{nid.error}</FormHelperText>
            </FormControl>
          </Box>

          <Box mt={2} mb={2}>
            <Button
              disabled={idData.loading}
              color="primary"
              fullWidth
              variant="contained"
              disableElevation
              onClick={() => {
                onSearchClick();
              }}
              className={classes.btn}
            >
              {idData.loading ? <CircularProgress size={23} /> : "Continue"}
            </Button>
          </Box>
        </Box>
      </Container>
      <Container maxWidth="lg">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          mt={12}
          alignContent="center"
          width={1}
        >
          <div className={classes.ln2} />
          <Typography variant="h5" gutterBottom>
            <b>Pre-registration benefits</b>
          </Typography>
          <div className={classes.ln} />
        </Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          mb={10}
          alignContent="center"
          width={1}
        >
          <Box width={!fullScreen ? 1 / 2 : 1}>
            <Typography align="center">
              Card pre-registration is a way of booking your SafariBus card
              online and get it at one of our branches without waiting in
              queues.
            </Typography>
          </Box>
        </Box>

        <Grid container justify="center" alignContent="center">
          <Grid item xs={12} sm={4} md={3}>
            <CardContent>
              <Box display="flex" justifyContent="center" width={1} mb={2}>
                <Avatar className={classes.green}>
                  <Timeline fontSize="large" />
                </Avatar>
              </Box>

              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                align="center"
                color="primary"
              >
                No queues
              </Typography>
              <Typography color="textSecondary" component="p" align="center">
                Don't waste your time queuing on our branches for your card, do
                your registration before and you will come only to pick it after
                showing your ID number.
              </Typography>
            </CardContent>
          </Grid>

          <Grid item xs={12} sm={4} md={3}>
            <CardContent>
              <Box display="flex" justifyContent="center" width={1} mb={2}>
                <Avatar className={classes.green}>
                  <Equalizer fontSize="large" />
                </Avatar>
              </Box>
              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                align="center"
                color="primary"
              >
                No queues
              </Typography>
              <Typography color="textSecondary" component="p" align="center">
                Don't waste your time queuing on our branches for your card, do
                your registration before and you will come only to pick it after
                showing your ID number.
              </Typography>
            </CardContent>
          </Grid>

          <Grid item xs={12} sm={4} md={3}>
            <CardContent>
              <Box display="flex" justifyContent="center" width={1} mb={2}>
                <Avatar className={classes.green}>
                  <DirectionsBus fontSize="large" />
                </Avatar>
              </Box>
              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                align="center"
                color="primary"
              >
                No queues
              </Typography>
              <Typography color="textSecondary" component="p" align="center">
                Don't waste your time queuing on our branches for your card, do
                your registration before and you will come only to pick it after
                showing your ID number.
              </Typography>
            </CardContent>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </div>
  );
}

export default withLocalize(PreRegistration);
